import { render } from "./LayerPreviewImage.vue?vue&type=template&id=5dc21c9e"
import script from "./LayerPreviewImage.vue?vue&type=script&lang=js"
export * from "./LayerPreviewImage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__